import {
    Texture
} from 'three';

//Class that manage and create all points of a scene with particular configuration to allow movement;
export default class TouchTexture {
    private parent: any = null;
    private size: any = null;
    private maxAge: any = null;
    private radius: any = null;
    private trail: any = null;
    private ctx: any = null;
    private canvas: any = null;
    private texture: any = null;

    constructor(parent : any) {
        this.parent = parent;
        this.size = 64
        this.maxAge = 120;
        this.radius = 0.10;
        this.trail = [];

        this.initTexture();
    }

    initTexture() {
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.canvas.height = 64;
        this.ctx = this.canvas.getContext('2d');
        this.ctx.fillStyle = 'black';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        this.texture = new Texture(this.canvas);

        this.canvas.id = 'touchTexture';
        this.canvas.style.width = this.canvas.style.height = `${this.canvas.width}px`;
    }

    update() {
        this.clear();

        this.trail.forEach((point : any, i: number) => {
            point.age++;
            if (point.age > this.maxAge) {
                this.trail.splice(i, 1);
            }
        });

        this.trail.forEach((point : any, i: number) => {
            this.drawTouch(point);
        });

        this.texture.needsPMREMUpdate = true;
        this.texture.needsUpdate = true;
    }

    clear() {
        this.ctx.fillStyle = 'black';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }

    drawTouch(point : any) {
        const pos = {
            x: point.x * this.size,
            y: (1 - point.y) * this.size,
        };

        let intensity = 1;
        if (point.age < this.maxAge * 0.3) {
            intensity = Math.sin((point.age / (this.maxAge * 0.3)) * (Math.PI/2))
        } else {
            intensity = Math.sin((1 - (point.age - this.maxAge * 0.3) / (this.maxAge * 0.7)) * (Math.PI/2))
        }

        intensity *= point.force;

        const radius = this.size * this.radius * intensity;

        const grd = this.ctx.createRadialGradient(pos.x, pos.y, radius * 0.25, pos.x, pos.y, radius);
        grd.addColorStop(0, `rgba(255, 255, 255, 0.5)`);
        grd.addColorStop(1, 'rgba(0, 0, 0, 0.0)');

        this.ctx.beginPath();
        this.ctx.fillStyle = grd;
        this.ctx.arc(pos.x, pos.y, radius, 0, Math.PI * 2);
        this.ctx.fill();
    }

    addTouch(point : any) {
        let force = 0;
        const last = this.trail[this.trail.length - 1];
        if (last) {
            const dx = last.x - point.x;
            const dy = last.y - point.y;
            const dd = dx * dx + dy * dy;
            force = Math.min(dd * 10000, 1);
        }
        this.trail.push({ x: point.x, y: point.y, age: 0, force });
    }
}
